<template>
  <div>
    <h1 class="common__main-title">Application</h1>
    <Search class="search" @changedConditions="changeConditions"/>
    <div class="d-flex justify-content-end mb-3">
      <b-button pill variant="primary" :to="{ name:'ApplicationAdd' }" class="mr-2">
        Register
      </b-button>
    </div>

    <div class="pager-box">
      <PagerComponent v-model="pager" @changePage="changePage" class="mb-2" />
    </div>
    <ApplicationsTable />
    <div class="pager-box">
      <PagerComponent v-model="pager" @changePage="changePage" />
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import PagerComponent from '@/components/parts/Pager.vue';
import Search from '@/components/parts/application/ApplicationSearch.vue';
import {
  Application,
  ApplicationSearchConditions,
  ApplicationStatus,
  applicationStatusCode,
  ApplicationType,
  applicationTypeCode,
} from '@/store/applications/types';
import ApplicationsTable from '@/components/parts/application/ApplicationsTable.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { RootState } from '@/store/types';
import { Pager } from '@/store/pager.types';

export default Vue.extend({
  components: {
    Search,
    PagerComponent,
    Loading,
    ApplicationsTable,
  },

  filters: {
    type(type: applicationTypeCode): string {
      return ApplicationType[type]
    },
    status(status: applicationStatusCode): string {
      return ApplicationStatus[status]
    },
  },

  data: (): {
    conditions: ApplicationSearchConditions|null,
    applications: Application[],
    isLoading: boolean,
  } => ({
    conditions: null,
    applications: [],
    isLoading: false,
  }),

  computed: {
    pager(): Pager {
      return (this.$store.state as RootState).applications.pager
    },
  },

  created(): void {
    this.fetchApplications()
  },

  methods: {
    changeConditions(conditions: ApplicationSearchConditions): void {
      this.conditions = conditions
      this.fetchApplications()
    },

    changePage(page: number) {
      this.fetchApplications(page)
    },

    fetchApplications(page: number = 1): void {
      if (this.isLoading) {
        return
      }

      this.isLoading = true
      this.$store.dispatch('fetchApplications', { conditions: this.conditions, page })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
})
</script>
